import request from '@/utils/request'

// 待退款列表
export function fetchList(data) {
	return request({
		url: '/oms/userOrder/return/queryRefundList',
		method: 'POST',
		data
	})
}

// 更新打款状态
export function updateRefunded(data) {
	return request({
		url: '/oms/userOrder/return/updateRefunded',
		method: 'POST',
		data
	})
}

// 填写客户的退款接收卡号
export function updateCardNo(data) {
	return request({
		url: '/oms/userOrder/return/updateCardNo',
		method: 'POST',
		data
	})
}



// WEBPACK FOOTER //
// ./src/api/oms/refund.js